/**
 * Removes the leading slash from a string.
 *
 * @param {string} str - The input string.
 * @return {string} - The modified string without the trailing slash.
 */
export function removeLeadingSlash(str: string): string {
	return str.replace(/^\/+/, '');
}
